import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.html',
    
})
export class ErrorComponent {}


// WEBPACK FOOTER //
// ./src/app/views/pages/base/config/error/error.component.ts